import { useActionWhenVisible } from 'client/common/hooks/useActionWhenVisible'
import { useFetch } from 'use-http'
import { getByIdProductsUrl } from 'client/common/xhr/gateway'
import { EMPTY_RESPONSE_INTERCEPTOR, getHeaders } from 'client/common/hooks/useCrossSellFetch'

export const useFetchLastViewedData = (props, inView, productCodes) => {
  const options = { ...getHeaders(props), ...EMPTY_RESPONSE_INTERCEPTOR }
  const { data, error, loading, get } = useFetch(getByIdProductsUrl({ ...props, productCodes }), options)

  const actionProps = {
    action: get,
    inView,
    isActionDisabled: data
  }
  useActionWhenVisible(actionProps)

  return { data, error, loading }
}
